<script>
  import { toggleFilterMenu, filterMenu, getFilterMenu } from './stores/filter-store.js';
  import { availableFacets, clearSelectedFacets } from './stores/facet-store.js';
  import FacetDrawer from './FacetDrawer.svelte';
  import Icon from './Icon.svelte';

  /*
    If it is desktop and the filter is open, keep it open.
    If it is desktop and the filter is closed, keep it closed.
    If it is mobile, always close the filter.
  */
  function setFilter() {
    const breakpoint = window.matchMedia('(min-width:1024px)');
    filterMenu.set(getFilterMenu() && breakpoint.matches);
  }
  setFilter();
  let screenWidth = window.offsetWidth;

  window.addEventListener('resize', () => {
    // Check if the screen width has changed...
    if (screenWidth !== window.offsetWidth) {
      // If so, set the filter.
      setFilter();

      // Make sure we update the current screen width.
      screenWidth = window.offsetWidth;
    }
  });
</script>

<style>
  .sidebar {
    transform: translateX(0);
  }

  .sidebar[data-visible="false"] {
    transform: translateX(-2000px);
    display: none;
  }

  @media (max-width: 1023px) {
    .sidebar {
      transform: translateX(0);
      transition: all 400ms ease-in-out;
    }
    .sidebar[data-visible="false"] {
      transform: translateY(2000px);
      display: flex;
  }
}
</style>

<aside class="sidebar spacer pb-[78px] lg:p-0 bg-white w-screen h-screen lg:w-full fixed lg:static left-0 top-0 lg:h-fit z-40 lg:z-0 flex flex-col items-start" data-visible={$filterMenu}>
  <div class="lg:hidden border-b border-brand-blue text-brand-blue flex justify-between py-2 w-full mb-s">
    <div
      class="font-body font-medium stretch-semi-expanded text-b2 flex items-center"
    >
      <Icon icon="filter" h={15} w={20} classes="mr-1" />
      Filter By
    </div>

    <button class="btn text-b2 font-body font-normal flex items-center text-accent-blue" on:click={toggleFilterMenu}>
      <span class="mr-1">Close</span>
      <Icon icon="close" h={12} w={12} />
    </button>
  </div>

  <div class="w-full overflow-y-auto lg:overflow-visible">
    {#each $availableFacets as facet }
      <FacetDrawer {facet} />
    {/each}
  </div>

  <div class="fixed lg:static left-0 bottom-0 w-full bg-brand-blue lg:bg-white spacer lg:px-0 py-m-mobile flex space-x-1 xl:mt-xl">
    <button class="btn btn--outline btn--white grow lg:btn--blue btn--small xs:btn--medium xl:btn--large" on:click={clearSelectedFacets}>Clear All</button>
    <button class="btn btn--solid btn--yellow grow lg:invisible btn--small xs:btn--medium xl:btn--large" on:click={toggleFilterMenu}>Apply</button>
  </div>
</aside>
